<template>
  <b-avatar
    v-if="avatarThumbnail"
    :size="cssSize"
    :src="avatarThumbnail"
  ></b-avatar>
  <b-avatar
    v-else-if="name"
    :size="cssSize"
    :text="getInitialsFromName(name)"
    class="bg--primary"
  ></b-avatar>
  <b-avatar
    v-else
    :size="cssSize"
    variant="primary"
    class="bg--primary"
    icon="people-fill"
  ></b-avatar>
</template>

<script>
import { getInitialsFromName } from "@/utils/utils";

export default {
  name: "AvatarItem",

  props: {
    name: { type: String },
    avatarThumbnail: { type: String },
    remSize: { type: Number, default: 8.4 }
  },

  computed: {
    cssSize() {
      return `${this.remSize}rem`;
    }
  },

  methods: {
    getInitialsFromName
  }
};
</script>

<style>
</style>